import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { deviceMax } from '../../theme/breakpoints'
import Button from '../Button/Button'

export const StyledBlock = styled.div`
  position: relative;
  align-items: center;
  justify-content: space-between;
  display: flex;
  border-radius: ${pxToRem(5)};
  margin: ${pxToRem(10)};
  padding: ${pxToRem(20)};
  width: 100%;
  max-width: ${pxToRem(384)};
  background-color: ${({ theme }) => theme.colors.primary.blue};
  @media ${deviceMax.mobileL} {
    flex-direction: column;
  }
`

export const StyledBlockText = styled.div`
  flex: 1;
  display: flex;
  margin: 0 auto;
  padding: 0;
  height: ${pxToRem(50)};
`

export const StyledNumber = styled.p`
  align-items: center;
  display: flex;
  font-weight: ${({ theme }) => theme.fonts.weight.black};
  font-size: ${pxToRem(45)};
  line-height: ${pxToRem(72)};
  @media ${deviceMax.mobileL} {
    margin-right: ${pxToRem(10)};
  }
`

export const StyledText = styled.p`
  justify-content: center;
  align-items: center;
  display: flex;
  padding: 0 ${pxToRem(10)};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${pxToRem(22)};
  text-align: center;
  @media ${deviceMax.mobileL} {
    margin-right: ${pxToRem(10)};
  }
`

export const StyledButton = styled(Button)`
  display: flex;
  text-align: center;
  @media ${deviceMax.mobileL} {
    justify-content: center;
    width: 100%;
  }
`
